var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fcfcfc",
  d: "M0 85.331h512v341.337H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M352 233.88h-22.154c0 40.784-33.063 73.846-73.846 73.846-40.785 0-73.846-33.062-73.846-73.846H160c0 43.931 29.509 80.969 69.787 92.377-4.415 8.389-3.743 18.951 2.564 26.822l24.141-19.346 24.141 19.346c6.371-7.95 6.998-18.646 2.434-27.075C322.905 314.318 352 277.5 352 233.88z",
  fill: "#6da544"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M196.923 226.497s0 36.923 36.923 36.923l7.385 7.385H256s7.385-22.154 22.154-22.154c0 0 0-14.769 14.769-14.769h22.154s-7.385-29.538 29.538-51.692l-14.769-7.385s-51.692 36.923-88.615 29.538v14.769h-14.769l-7.385-7.385-22.154 14.77z",
  fill: "#ffda44"
})));

export default SvgCy;